// extracted by mini-css-extract-plugin
module.exports = {"signInModalV1Body":"az_nx","modalSpinner":"az_ox"};